<template>
  <a-drawer
    :title="(action == 'add' ? '添加' : '修改') + '污染源'"
    :width="400"
    :visible="visible"
    @close="
      $emit('onClose', false);
      form.resetFields();
    "
  >
    <a-form
      :form="form"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
      @submit="handleOk"
    >
      <a-form-item label="id" v-show="false">
        <a-input v-decorator="['id']"> </a-input>
      </a-form-item>
      <a-form-item label="污染源名称">
        <a-input
          placeholder="请输入污染源名称"
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请选择站点名称' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="所属河道">
        <a-input
          placeholder="请输入所属河道"
          v-decorator="[
            'river',
            { rules: [{ required: true, message: '请输入所属河道' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="所属街道">
        <a-input
          placeholder="请输入所属街道"
          v-decorator="[
            'street',
            { rules: [{ required: true, message: '请输入所属街道' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="发现时间">
        <a-date-picker
          style="width: 100%;"
          placeholder="请选择发现时间"
          v-decorator="[
            'time',
            { rules: [{ required: true, message: '请选择发现时间' }] }
          ]"
          format="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
        />
      </a-form-item>
      <a-form-item label="污染类别">
        <a-input
          placeholder="请输入污染类别"
          v-decorator="[
            'category',
            { rules: [{ required: true, message: '请输入污染类别' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="一类污染源">
        <a-input
          placeholder="请输入一类污染源"
          v-decorator="[
            'first_category',
            { rules: [{ required: true, message: '请输入一类污染源' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="二类污染源">
        <a-input
          placeholder="请输入二类污染源"
          v-decorator="[
            'second_category',
            { rules: [{ required: true, message: '请输入二类污染源' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="发生位置">
        <a-input
          placeholder="请输入发生位置"
          v-decorator="[
            'location',
            { rules: [{ required: true, message: '请输入发生位置' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="核实">
        <a-switch
          v-decorator="[
            'is_check',
            { initialValue: false, valuePropName: 'checked' }
          ]"
        />
      </a-form-item>
      <a-form-item label="整改">
        <a-switch
          v-decorator="[
            'is_reform',
            { initialValue: false, valuePropName: 'checked' }
          ]"
        />
      </a-form-item>
      <a-form-item label="整改时间">
        <a-date-picker
          style="width: 100%;"
          placeholder="请选择整改时间"
          v-decorator="['reform_time']"
          format="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
        />
      </a-form-item>
      <a-form-item label="整改人员">
        <a-input
          placeholder="请输入整改人员"
          v-decorator="[
            'reform_person',
            { rules: [{ required: true, message: '请输入整改人员' }] }
          ]"
          allowClear
        ></a-input>
        <!-- <a-select
          v-decorator="[
            'reform_person',
            {
              initialValue: '',
              rules: [{ required: true, message: '请选择整改人员' }]
            }
          ]"
          placeholder="请选择整改人员"
          option-filter-prop="children"
          showSearch
          @search="userSearch"
          @popupScroll="userPopupScroll"
        >
          <a-select-option
            v-for="item in operationUserList"
            :key="item.id"
            :value="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select> -->
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea v-decorator="['remark']" />
      </a-form-item>
    </a-form>

    <div class="drawer-btn">
      <a-button
        :style="{ marginRight: '8px' }"
        @click="
          $emit('update:visible', false);
          form.resetFields();
        "
      >
        取消
      </a-button>
      <a-button type="primary" @click="handleOk">
        确定
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { getOperationUserList, addPollutant, updatePollutant } from "@/api/api";
import moment from "moment";
const editFields = [
  "id",
  "name",
  "river",
  "street",
  "time",
  "category",
  "first_category",
  "second_category",
  "location",
  "is_check",
  "is_reform",
  "reform_time",
  "reform_person",
  "remark"
];

export default {
  data() {
    return {
      operationUserList: [],
      userPage: 1,
      userSize: 10,
      userTotal: 0,
      userName: "",
      form: this.$form.createForm(this)
    };
  },
  props: {
    action: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["authUserInfo", "sensortypes", "groupTree", "alarmTypeList"]),
    ...mapGetters(["defaultInfo"])
  },
  mounted() {
    // this.getOperationUserList();
  },
  watch: {
    visible() {
      if (this.action == "edit") {
        this.updateCurPollutant();
      }
    }
  },
  methods: {
    moment,
    async getOperationUserList() {
      try {
        let res = await getOperationUserList({
          group_id: this.defaultInfo.defaultGroupId,
          page: this.userPage,
          size: this.userSize,
          search: this.userName
        });
        let data = res.data.items;
        this.userTotal = res.data.total;
        this.operationUserList = [...this.operationUserList, ...data];
      } catch (error) {
        console.log(error);
      }
    },
    async userSearch(v) {
      this.userName = v;
      this.userPage = 1;
      this.operationUserList = [];
      await this.getOperationUserList();
    },
    userPopupScroll(e) {
      const { target } = e;
      const { scrollTop, scrollHeight, clientHeight } = target;

      if (scrollTop + clientHeight == scrollHeight) {
        // 已经到达底部，触发分页逻辑
        if (this.userPage * this.userSize < this.userTotal) {
          this.userPage++;
          this.getOperationUserList();
        }
      }
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (err) return;
        let p = "";
        const params = {
          name: values.name,
          river: values.river,
          street: values.street,
          time: values.time,
          category: values.category,
          first_category: values.first_category,
          second_category: values.second_category,
          location: values.location,
          is_check: values.is_check ? true : false,
          is_reform: values.is_reform ? true : false,
          reform_time: values.reform_time,
          reform_person: values.reform_person,
          remark: values.remark
        };
        params.lat = this.record.lat;
        params.lng = this.record.lng;
        if (this.action == "add") {
          prams.group_id = this.defaultInfo.defaultGroupId;
          p = addPollutant;
        } else {
          params.id = values.id;
          p = updatePollutant;
        }

        try {
          let res = await p(params);
          this.form.resetFields();
          this.$message.success(res.data.msg);
          this.$emit("onOk", false);
        } catch (error) {
          this.$emit("onClose", false);
          console.log(error);
        }
      });
    },
    updateCurPollutant() {
      editFields.forEach(v => this.form.getFieldDecorator(v));
      const form_ = {};
      form_["id"] = this.record["id"];
      form_["name"] = this.record["name"];
      form_["river"] = this.record["river"];
      form_["street"] = this.record["street"];
      form_["time"] = this.record["time"];
      form_["category"] = this.record["category"];
      form_["first_category"] = this.record["first_category"];
      form_["second_category"] = this.record["second_category"];
      form_["location"] = this.record["location"];
      form_["is_check"] = this.record["is_check"];
      form_["is_reform"] = this.record["is_reform"];
      form_["reform_time"] = this.record["reform_time"];
      form_["reform_person"] = this.record["reform_person"];
      form_["remark"] = this.record["remark"];
      this.$nextTick(() => {
        this.form.setFieldsValue(form_);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.drawer-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
